<template>
  <div v-if="status" :class="classDef">
    <div class="d-flex justify-content-start align-items-center" v-if="status.locked || status.expired || status.disabled || status.passwordExpired">
      <span class="badge badge-danger py-2 px-2" v-if="status.locked == true"><i class="fas fa-user-lock pr-1"></i>Locked</span>
      <span class="badge badge-danger py-2 px-2" v-if="status.expired == true">Expired</span>
      <span class="badge badge-danger py-2 px-2" v-if="status.disabled == true">Disabled</span>
      <span class="badge badge-danger py-2 px-2" v-if="status.passwordExpired == true">Password Expired</span>
    </div>
    <div class="d-flex justify-content-start align-items-center" v-else>
      <span class="badge badge-success py-2 px-2"><i class="fas fa-check pr-2"></i>OK</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAccountStatus',
  props: {
    status: Object,
    classDef: {
      type: String,
      default: 'd-flex flex-row justify-content-around align-items-end'
    }
  }
}
</script>

<style scoped lang="scss">

.badge {
    font-size: inherit;
    font-weight: 600;
    cursor: default;
    margin-right: 0.5rem
  }
</style>
